<template>
  <div
    class="services-list-teaser"
    :class="[
      `services-list-teaser--size_${services.length}`
    ]"
  >
    <service-teaser
      v-for="(service, index) in services"
      :key="index"
      class="services-list-teaser__service"
      v-bind="service"
    />
  </div>
</template>

<script>
  import ServiceTeaser from '../serviceTeaser/serviceTeaser.vue';

  export default {
    components: {
      ServiceTeaser
    },
    props: {
      services: {
        type: Array,
        default() {
          return [];
        }
      }
    }
  };

</script>
